import React, { useState } from 'react';
import BurgerMenu from '../components/BurgerMenu';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Telephone from '../components/Telephone';
import Titre_contact from '../components/Titre_contact';

const Contact = () => {
    const [values, setValues] = useState({
        name: "",
        subject: "",
        message: ""
    });

    const handleValues = ({ type, target }) => {
        const newValue = target.value;
        setValues({ ...values, [type]: newValue });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const { name, subject, message } = values; 
        window.location = `mailto:dkd0835@orange.fr?subject=${subject}&body=Nom:${name}, Message:${message}`;
    };

    return (
        <div>
            <Header />
            <Titre_contact />

            <Telephone />

            <div className="container-formulaire">
                <form className="contact-form" onSubmit={(e) => handleSubmit(e)}>
                    <div className="form-content">
                        <input
                            type="text"
                            placeholder="Nom, Prénom"
                            name="flibidi"
                            onChange={({ target }) => handleValues({ type: "name", target })}
                        />
                        <input
                            type="text"
                            placeholder="Objet"
                            onChange={({ target }) => handleValues({ type: "subject", target })}
                        />
                        <textarea
                            name="message"
                            onChange={({ target }) => handleValues({ type: "message", target })}
                            placeholder="Votre message"
                        />
                    </div>
                    <input
                    className="button"
                    type="button"
                    value="Envoyer"
                    onClick={handleSubmit}
                    />
                    <div className="form-message"></div>
                </form>
            </div>

            <Footer />
            <BurgerMenu />
        </div>
    );
  };

export default Contact;